import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/majaegeon.github.io/majaegeon.github.io/src/templates/page-template.js";
import PostList from "../components/postList";
import ContentHeader from "../components/contentHeader";
import { graphql } from "gatsby";
export const pageQuery = graphql`
    query {
        allMdx(sort: {fields: frontmatter___date, order: DESC}, limit: 2000) {
            totalCount
            edges {
                node {
                    frontmatter {
                        categories
                        date
                        notice
                        pinned
                        title
                        thumbnail
                    }
                    excerpt(truncate: true)
                    id
                    slug
                }
            }
        }
    }
`;
export const _frontmatter = {};
const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <PostList posts={props.data.allMdx.edges.slice(0, 7)} contentHeader={<ContentHeader url="/posts" header={<div>전체 글 <span style={{
        color: '#ef402f'
      }}>{props.data.allMdx.totalCount}</span></div>} mdxType="ContentHeader" />} mdxType="PostList" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      